export default {
  data: () => ({
    pagination: {},
    list: [],
    loading: false,
    error: false,
    lastRequest: null,
    totalPages: null,
    totalCount: null,
    search: null,
  }),
  methods: {
    getItems () {
      this.loading = true;
      this.error = false;
      let params = this.getListQueryParams();
      this.$emit('getItems', params);
      this.$http
        .get(this.getBaseApiUrl(), {
          params: params,
          before: request => {
            if (this.lastRequest) {
              this.lastRequest.abort();
            }
            this.lastRequest = request;
          }
        })
        .then(r => {
          if (r.ok) {
          }
          return r.json();
        })
        .then(
          list => {
            this.list = list.list;
            this.totalCount = Number(list.totalNumberOfRows);
            this.totalPages = Math.ceil(Number(
              list.totalNumberOfRows/this.pagination.itemsPerPage
            ));
            this.loading = false;
          },
          error => {
            if (error.status > 0) {
              this.list = [];
            }
            this.error = true;
            this.loading = false;
          }
        );
    },
    getListQueryParams () {
      return {};
    },
    getBaseApiUrl () {
      return process.env.VUE_APP_ROOT_API + this.dataSourceUrl;
    },
  },
}
